import { setRemarketingTag } from 'ha/modules/Analytics/actions';

import { OFFER } from '../constants/Actions';
import { makeRequestAction } from './actions';
import { ERROR_MESSAGES } from '../constants/Errors';

export default (conversationId, { price, startDate, endDate }) => (
  dispatch,
  _,
  { apiV2 },
) => {
  dispatch(makeRequestAction.start({ type: OFFER }));

  return apiV2
    .makeSpecialOffer(conversationId, { price, startDate, endDate })
    .then(({ data }) =>
      apiV2
        .getConversationMessages(conversationId)
        .then(messages => [data, messages]),
    )
    .then(([data, { data: { messages } }]) => {
      dispatch(
        setRemarketingTag({
          hrental_id: data.listingId,
          hrental_pagetype: 'proposalsent',
          hrental_startdate: data.startDate,
          hrental_enddate: data.endDate,
          hrental_totalvalue: data.total,
        }),
      );

      dispatch(makeRequestAction.done({ ...data, messages }));
    })
    .catch(({ cause }) => {
      if (cause) {
        switch (cause.status) {
          case 400:
            if (cause.response.errors[0].key === 'startDate') {
              dispatch(makeRequestAction.error(ERROR_MESSAGES.startDate));
            } else {
              dispatch(makeRequestAction.error(ERROR_MESSAGES[400]));
            }
            break;
          default:
            dispatch(makeRequestAction.error(ERROR_MESSAGES.DEFAULT));
        }

        return;
      }

      dispatch(makeRequestAction.error(ERROR_MESSAGES.DEFAULT));
    });
};
